module.exports = __webpack_public_path__ + "static/media/NanumSquareB.ada293a4.woff";